import { Box, Flex, Image, Text } from '@chakra-ui/react';
import React from 'react';

const OfferDoc = ({ userDetails, agree, date }) => {
    const containerStyle = {
        width: '600px',
        margin: '0 auto',
        // paddingTop: '.2em',
        paddingBottom: '1em',
        paddingLeft: '3.5em',
        paddingRight: '3.5em',
        fontFamily: 'Arial, sans-serif',
        'page-break-after': 'always',
        boxShadow: 'lg',

    };

    const headingStyle = {
        color: '#004080',
        fontSize: '9pt',
        fontWeight: 700,
        paddingBottom: '8px',
    };

    const linkStyle = {
        color: '#0066cc',
        textDecoration: 'underline',
    };
    const paraSytle = {
        paddingBottom: '10px',
        fontSize: '7pt',
        textAlign: 'justify'
    }
    return (
        <div style={containerStyle}>
            <Image w={'80%'}
                mx={'auto'} src={'/images/letter_head.png'} />

            <br />
            <p
                style={{
                    paddingBottom: '10px',
                    fontSize: '8pt',
                    textAlign: 'right',

                }}
            >{date}</p>
            <p style={paraSytle}>
                {userDetails &&
                    <>
                        {userDetails?.fname} {userDetails?.oname} {userDetails?.lname},<br />
                        {userDetails?.house_number} {userDetails?.address_line1}, <br />
                        {userDetails?.town_city},  {userDetails?.county}, <br />
                        {userDetails?.post_code}.
                    </>
                }
            </p>
            <p style={paraSytle}>Dear {userDetails?.fname},</p>

            <h2 style={headingStyle}>Provisional Offer of Employment {userDetails?.job_title}</h2>

            <p style={paraSytle}>Congratulations on your success at the interview. We are happy to proceed with a Provisional Offer of Employment for you.</p>
            <p style={paraSytle}>If you are happy with this, kindly accept the conditional offer of employment.</p>

            <p style={paraSytle}>This offer is subject to an Enhanced Disclosure & Barring Service, satisfactory references, and your Right to Work in the UK.</p>

            <h3 style={headingStyle}>References</h3>
            <p style={paraSytle}>As part of our employment checks, we need to take up references covering at least the last 3 years of employment/education from you. If you have any gaps in your employment/education during the last 3 years, we will require a character reference.</p>
            <p style={paraSytle}>If you can confirm who your line employer/manager/tutor was during the last 3 years and enter their email address/details and phone number on the portal. We cannot accept personal email addresses for references; it must be a professional work email address.</p>

            
            <p style={paraSytle}>If you are not sure about anything in this letter or have any questions, please feel free to call 02080797305.</p>
            <p style={paraSytle}>Once again, congratulations on your offer, and we hope that you have a happy and fulfilling journey with us.</p>
            <p style={paraSytle}></p>
            <p style={paraSytle}>
                <p style={paraSytle}></p>
                <p style={paraSytle}></p>
            </p>
            <p style={paraSytle}>
                Yours sincerely                <br />
                Litmus Recruitment Team            <br />
                Tel: 02080797305          </p>
            {
                agree &&
                <Box my={2} alignSelf={'center'} bg={'green.100'} borderRadius={'lg'} p={3}>
                    <Text color={'green.500'} fontWeight={800} fontSize={'9pt'}>I acknowledge receipt of the terms and conditions of my employment and accept the terms and conditions atteched.
                        Accepted by: {userDetails?.fname + ' ' + userDetails?.lname}</Text>
                </Box>
            }

        </div>
    );
}

export default OfferDoc;
